import { Injectable } from '@angular/core';
import {
  AngularFirestore,
  AngularFirestoreDocument,
} from '@angular/fire/firestore';
import { AuthenticationService } from 'src/app/auth/fire-auth/authentication.service';
import { Ptransaction } from '../../../model/ptransaction';

@Injectable({
  providedIn: 'root',
})
export class PtransactionsStoreService {
  constructor(
    private angularFireStore: AngularFirestore,
    private authenticationService: AuthenticationService
  ) {}

  private getUser() {
    return this.authenticationService.currentUserId;
  }

  private getTransactionsFromEveryOne() {
    return this.angularFireStore.collection(`transactions`).snapshotChanges();
  }

  addPTransaction(ptransaction: Ptransaction) {
    return this.angularFireStore.collection(`ptransactions`).add(ptransaction);
  }

  getPTransaction(id) {
    return this.angularFireStore
      .collection(`ptransactions`)
      .doc(id)
      .snapshotChanges();
  }

  getAllPTransactions() {
    return this.angularFireStore
      .collection(`ptransactions`, (ref) =>
        ref.where('owner', '==', this.getUser())
      )
      .valueChanges({ idField: 'id' });
  }

  updatePTransaction(ptransaction: Ptransaction) {
    console.log(ptransaction);
    return this.angularFireStore
      .collection(`ptransactions`)
      .doc(ptransaction.id)
      .set(ptransaction);
  }

  deletePTransaction(ptransaction: Ptransaction) {
    return this.angularFireStore
      .doc(`ptransactions/${ptransaction.id}`)
      .delete();
  }
}
